<template>
  <Layout>
    <PageHeader
      :title="title"
      :subTitle="subTitle"
      :items="breadcrumbItems"
      hasBreadcrumb
      hasBackButton
    />

    <b-tabs v-model="tabIndex">
      <template v-for="(item, index) in tabItems">
        <b-tab v-if="item.isShow" :key="index" :title="$t(item.label)" />
      </template>
    </b-tabs>

    <b-card>
      <!-- eslint-disable-next-line vue/require-component-is -->
      <component :is="tabItems[tabIndex].content" />
    </b-card>
  </Layout>
</template>

<script>
import appConfig from '@/app.config'
import Layout from '@/router/layouts/main'
import PageHeader from '@/components/page-header-v2.vue'
import CancelReason from './contents/CancelReason.vue'
import RescheduleReason from './contents/RescheduleReason.vue'
import TransferReason from './contents/TransferReason.vue'

export default {
  page: {
    title: 'Setting',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      tabIndex: 0,
      tabItems: [
        {
          label: 'setting.reasonCancel.label',
          content: CancelReason,
          isShow: true,
        },
        {
          label: 'setting.reasonReschedule.label',
          content: RescheduleReason,
          isShow: true,
        },
        {
          label: 'setting.reasonTransfer.label',
          content: TransferReason,
          isShow: true,
        },
      ],
    }
  },
  computed: {
    title() {
      return this.$t('setting.homePage.delivery')
    },
    subTitle() {
      return this.$t('setting.homePage.textDelivery')
    },
    breadcrumbItems() {
      return [
        {
          text: this.$t('setting.list.deliverySetting.setting'),
          to: '/setting',
        },
        {
          text: this.$t('setting.list.deliverySetting.delivery'),
        },
      ]
    },
  },
}
</script>
